import React from "react";
import "./How.css";
import WOW from 'wowjs';

class How extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        new WOW.WOW().init();
    }
    render() {
        return (
            <div className="how" name="How">
                <div className="container">
                    <h2 className="wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30">How it Works</h2>
                    <div className="how_main">
                        <div className="how_left wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30" >
                            <div className="how_left_main">
                                <h5>Squirrel is a wallet application and DeFi marketplace integrations where users can:
                                </h5>
                                <div className="how_left_block">
                                    <img src="img/how/icon_1.svg" />
                                    <span>Hold all digital assets in their own custody without private key storage </span>
                                </div>
                                <div className="how_left_block">
                                    <img src="img/how/icon_2.svg" />

                                    <span>Use DeFi applications within their wallet for borrowing, lending and other yield generation
                                    </span>
                                </div>
                                <div className="how_left_block">
                                    <img src="img/how/icon_3.svg" />
                                    <span>Send funds internationally
                                        to any username at a low cost
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="how_right wow animate__animated animate__flipInX" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30">
                            <div className="how_right_text">
                                There is no decentralized, non-custodial, recoverable, user friendly digital asset wallet that can manage digital assets, securities, and payments (connected with traditional banking) in a user friendly manner. Existing competitors lack cross-blockchain compatibility, recoverability, and traditional banking relationships for seamless onboarding to digital assets and decentralized finance. Existing DeFi applications, which are driving positive sentiment in the crypto industry, have over <span>$40 billion in capital allocated</span> within their smart contracts.</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default How;
